import { Button, Form, Input, Modal, notification, Spin, Typography } from "antd";
import React, { useEffect, useMemo } from "react";
import { useIntl } from "react-intl";
import { TariffType, useSubscriptionLicenseKey } from "services/rest/subscription";
import { useForm } from "antd/es/form/Form";
import { CopyOutlined } from "@ant-design/icons";

export type LicenseKeyInfoModalProps = {
  subscriptionId: string,
  licenseId: string,
  visible: boolean,
  onCancel: () => void,
}

export function LicenseKeyInfoModal(props: LicenseKeyInfoModalProps) {
  const { subscriptionId, licenseId, visible, onCancel } = props;
  const intl = useIntl();
  const [form] = useForm();

  const { response, loading, error } = useSubscriptionLicenseKey(subscriptionId, licenseId);

  useMemo(() => {
    if (error) {
      form.resetFields();

      notification.error({
        message: intl.formatMessage({ id: "jmix-store.license-key-info-modal.view-error" }),
        placement: "bottomLeft",
      });
    }
  }, [error]);

  useEffect(() => {
    if (response) {
      form.setFieldsValue({
        "sid": response.sid,
      });
    }
  }, [response]);

  const clipboard = () => {
    if (response && !error) {
      notification.success({
        message: intl.formatMessage({ id: "jmix-store.license-key-info-modal.copy-success" }),
        placement: "top",
      });
      navigator.clipboard.writeText(response.sid);
    }
  };

  return (
    <Modal
      centered
      destroyOnClose
      title={intl.formatMessage({ id: "jmix-store.license-key-info-modal.title" })}
      visible={visible}
      cancelButtonProps={{
        hidden: true
      }}
      onOk={onCancel}
      onCancel={onCancel}
    >
      <Spin spinning={loading}>
        <Form
          form={form}
          layout="vertical"
        >
          <Form.Item
            label={intl.formatMessage({ id: "jmix-store.license-key-info-modal.label" })}
          >
            <Input.Group compact>
              <Form.Item
                name="sid"
                noStyle
              >
                <Input
                  style={{ width: "calc(100% - 200px)" }}
                  disabled
                />
              </Form.Item>
              <Form.Item noStyle>
                <Button
                  icon={<CopyOutlined />}
                  onClick={clipboard}
                />
              </Form.Item>
            </Input.Group>
          </Form.Item>
          {
            response && !error &&
            <Typography>
              {
                response.subscription.tariff == TariffType.ENTERPRISE
                  ? intl.formatMessage({ id: "jmix-store.license-key-info-modal.enterprise-description" })
                  : intl.formatMessage({ id: "jmix-store.license-key-info-modal.default-description" })
              }
            </Typography>
          }
        </Form>
      </Spin>
    </Modal>
  );
}